import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ResponseNotificationService} from "../../../core/services/response-notification.service";
import {AuthenticationRestService} from "../../../core/services";
import {TokenApiModel} from "../../../api/models/token.api.model";
import {TokenDataProviderService} from "../../../core/services/token-data-provider.service";

@Component({
  selector: 'app-owner-change',
  templateUrl: './owner-change.component.html',
  styleUrls: ['./owner-change.component.scss']
})
export class OwnerChangeComponent implements OnInit {

  private token: string;
  public pin: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private as: AuthenticationRestService,
    private rns: ResponseNotificationService,
    private tokenDPS: TokenDataProviderService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.token = params.token;
      }
    );
  }

  submit(): void {
    if (this.token && typeof this.token === 'string') {
      if (this.pin.length === 6) {
        const token = new TokenApiModel();
        token.token = this.token;
        token.pin = this.pin;
        this.tokenDPS.loginFromOwnerChangeInvitation(token).subscribe({
          next: successResponse => {
            this.rns.emitMessage(successResponse.message);
          }
        })
          .add(() => {
            this.router.navigate(['/'])
          });
      }
    } else {
      this.rns.emitError('auth.change_owner.token_to_short_or_invalid');
    }
  }
}
